const coerceBaseUrl = () => {
  const raw = import.meta.env?.VITE_API_BASE_URL
  if (!raw) return ''
  const trimmed = String(raw).trim()
  if (!trimmed) return ''
  try {
    const url = new URL(trimmed)
    return url.href.replace(/\/$/, '')
  } catch {
    return trimmed.replace(/\/$/, '')
  }
}

const API_BASE_URL = coerceBaseUrl()

export const isAbsoluteUrl = (value: string) => /^https?:\/\//i.test(value)

export const resolveApiUrl = (input: string) => {
  if (isAbsoluteUrl(input)) return input
  if (!API_BASE_URL) return input
  return input.startsWith('/') ? `${API_BASE_URL}${input}` : `${API_BASE_URL}/${input}`
}

export const getApiBaseUrl = () => API_BASE_URL
